/**
 * LEGAL-3: Consent API client.
 * Records user consent to privacy policy and terms of service.
 */
import { apiFetch } from "./api.js";

/**
 * Record one or more consent actions (batch mode for signup flow).
 * @param {Array<{voterId: string, policyType: string, policyVersion: string, action: string}>} consents
 * @returns {Promise<{recorded: number, consents: Array}>}
 */
export async function recordConsents(consents) {
  return apiFetch("/api/consent", {
    method: "POST",
    body: JSON.stringify({ consents }),
  });
}

/**
 * Get the latest consent status for a voter.
 * @param {string} voterId
 * @returns {Promise<{consents: Array}>}
 */
export async function getVoterConsents(voterId) {
  return apiFetch(`/api/consent/${voterId}`);
}

/** Current policy versions — keep in sync with legal-content.js on landing page */
export const POLICY_VERSIONS = {
  privacy_policy: "1.0",
  terms_of_service: "1.0",
};
